import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../../../../context/LanguageContext';
import '../style/search-popup.css';
import { initializeGlobalProductSearch } from '../script/global-product-search';

const SearchPopup: React.FC = () => {
    const { t, language } = useLanguage();
    const translation = t as any;
    const searchPlaceholder = translation.STORE?.searchHere || (language === 'pt' ? 'Pesquisar Aqui' : 'Search Here');
    const initialized = useRef(false);

    useEffect(() => {
        // Initialize search functionality only once
        if (!initialized.current) {
            setTimeout(() => {
                initializeGlobalProductSearch();
            }, 500);
            initialized.current = true;
        }
    }, []);

    return (
        <div className="search-popup">
            <div className="color-layer"></div>
            <button className="close-search" type="button" aria-label="Close search">
                <span className="far fa-times fa-fw"></span>
            </button>
            <form method="post" onSubmit={(e) => e.preventDefault()}>
                <div className="form-group">
                    <input
                        type="search"
                        name="search-field"
                        defaultValue=""
                        placeholder={searchPlaceholder}
                        autoComplete="off"
                    />
                    <button type="submit" aria-label="Search">
                        <i className="fas fa-search"></i>
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SearchPopup;

